"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CollectionMeta_1 = __importDefault(require("./CollectionMeta"));
exports.default = CollectionMeta_1.default;
